var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1779_52403)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D9D2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9413 16.5H8.08733V15.506C8.08733 13.77 8.77333 12.902 10.7053 12.244L12.9453 11.474C14.0653 11.068 14.4573 10.69 14.4573 9.864C14.4573 8.87 13.8133 8.366 12.1333 8.366C10.2573 8.366 9.55733 9.024 9.55733 10.256V10.424H8.07333V10.284C8.07333 8.548 9.26333 6.98 12.1893 6.98C14.8493 6.98 15.9693 8.24 15.9693 9.892C15.9693 11.432 14.9753 12.244 13.3233 12.748L11.3493 13.35C10.0893 13.784 9.65533 14.232 9.65533 15.296L11.9233 15.142H15.9413V16.5Z",
    fill: "#523FC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1779_52403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveTwo);
export default __webpack_public_path__ + "static/media/inactive-two.a4378c5342c60737e7c8f85907168e90.svg";
export { ForwardRef as ReactComponent };